import { createSlice } from "@reduxjs/toolkit";
import HbsHastasividengeDTO from "src/models/IzlemGozlem/HbsHastasividengeDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

export interface IHastaSiviDengeState {
    hastaSiviDengeRefetch: boolean;
    hastaSiviDengeDialogOpen: boolean;
    hastaSiviDengeActiveRow: HbsHastasividengeDTO;
    hastaSiviDengeIptalNedenSecimOpen: boolean;
}

const HastaSiviDengeSlice = createSlice<
    IHastaSiviDengeState,
    MapReducerPayloads<IHastaSiviDengeState,
        {
            setHastaSiviDengeRefetch: boolean;
            setHastaSiviDengeDialogOpen: boolean;
            setHastaSiviDengeActiveRow: HbsHastasividengeDTO;
            setHastaSiviDengeIptalNedenSecimOpen: boolean;
        }
    >>({
        name: 'hastaSiviDenge',
        initialState: {
            hastaSiviDengeRefetch: false,
            hastaSiviDengeDialogOpen: false,
            hastaSiviDengeActiveRow: new HbsHastasividengeDTO(),
            hastaSiviDengeIptalNedenSecimOpen: false
        },
        reducers: {
            setHastaSiviDengeRefetch: (state, action) => {
                state.hastaSiviDengeRefetch = action.payload;
            },
            setHastaSiviDengeDialogOpen: (state, action) => {
                state.hastaSiviDengeDialogOpen = action.payload;
            },
            setHastaSiviDengeActiveRow: (state, action) => {
                state.hastaSiviDengeActiveRow = action.payload;
            },
            setHastaSiviDengeIptalNedenSecimOpen: (state, action) => {
                state.hastaSiviDengeIptalNedenSecimOpen = action.payload;
            }
        }
    });

export default HastaSiviDengeSlice;